import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import AppLayout from './components/AppLayout';

// Auth
import Auth from './pages/auth/Auth';
// import Auth from './pages/auth/Auth1';

// User Pages
import VerifyEmail from './pages/user/VerifyEmail';
// import Dashboard from './pages/user/Dashboard';
import Dashboard from './pages/user/Dashbaord-New';
import Profile from './pages/user/forms/components/Profile';
import NewApplication from './pages/user/NewApplication';
// import ApplicationHistory from './pages/user/ApplicationHistory';
import MyApplications from './pages/user/MyApplications';
// import ViewApplication from './pages/user/ViewApplication';
import ViewApplication from './pages/user/pages/ViewApplication-New';
import BulkReview from './pages/user/BulkReview';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import VisaTypeManagement from './pages/admin/VisaTypeManagement';
import DocumentConfiguration from './pages/admin/DocumentConfiguration';
import FeeMaster from './pages/admin/FeeMaster';
import ApplicationManagement from './pages/admin/ApplicationManagement';
// import ViewAdminApplication from './pages/admin/ViewAdminApplication';
import ViewAdminApplication from './pages/admin/ViewAdminApplication-New';
import UserManagement from './pages/admin/UserManagement';
import AgentManagement from './pages/admin/AgentManagement';

import './App.css';
import CreateNewApplication from './pages/user/pages/CreateNewApplication';

/* ------------------ USER AUTH GUARD ------------------ */
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return user ? children : <Navigate to="/auth?mode=login" />;
};



/* ------------------ ADMIN AUTH GUARD ------------------ */
const AdminRoute = ({ children }) => {
  const { admin, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return admin ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout>
          <Routes>

            {/* ---------- PUBLIC ---------- */}
            <Route path="/" element={<Navigate to="/auth?mode=login" />} />
            <Route path="/login" element={<Navigate to="/auth?mode=login" />} />
            <Route path="/register" element={<Navigate to="/auth?mode=register" />} />

            <Route path="/auth" element={<Auth />} />

            <Route path="/verify-email" element={<VerifyEmail />} />

            {/* ---------- USER ---------- */}
            {/* <Route
              path="/dashboard"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            /> */}

            <Route
              path="/dashboard"
              element={<PrivateRoute><Dashboard /></PrivateRoute>}
            />

            <Route
              path="/profile"
              element={<PrivateRoute><Profile /></PrivateRoute>}
            />
            <Route
              path="/create-new-application"
              // element={<PrivateRoute><NewApplication /></PrivateRoute>}
              element={<PrivateRoute><CreateNewApplication /></PrivateRoute>}

            />

            <Route
              path="/new-application"
              element={<PrivateRoute><NewApplication /></PrivateRoute>}


            />
            {/* <Route
              path="/applications"
              element={<PrivateRoute><ApplicationHistory /></PrivateRoute>}
            /> */}

             <Route
              path="/applications"
              element={<PrivateRoute><MyApplications /></PrivateRoute>}
            />

            {/* ✅ EDIT MUST COME BEFORE VIEW */}
            {/* <Route
              path="/applications/:id/edit"
              element={<PrivateRoute><EditApplication /></PrivateRoute>}
            /> */}

            {/* <Route
              path="/applications/:id"
              element={<PrivateRoute><ViewApplication /></PrivateRoute>}
            /> */}

           
           <Route path="/applications/:id" element={<ViewApplication />} />

            <Route
              path="/bulk-review"
              element={<PrivateRoute><BulkReview /></PrivateRoute>}
            />

            {/* ---------- ADMIN ---------- */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={<AdminRoute><AdminDashboard /></AdminRoute>}
            />
            <Route
              path="/admin/visa-types"
              element={<AdminRoute><VisaTypeManagement /></AdminRoute>}
            />
            <Route
              path="/admin/documents"
              element={<AdminRoute><DocumentConfiguration /></AdminRoute>}
            />
            <Route
              path="/admin/fee-master"
              element={<AdminRoute><FeeMaster /></AdminRoute>}
            />
            <Route
              path="/admin/applications"
              element={<AdminRoute><ApplicationManagement /></AdminRoute>}
            />
            <Route
              path="/admin/applications/:id"
              element={<AdminRoute><ViewAdminApplication /></AdminRoute>}
            />
            <Route
              path="/admin/users"
              element={<AdminRoute><UserManagement /></AdminRoute>}
            />
            <Route
              path="/admin/agents"
              element={<AdminRoute><AgentManagement /></AdminRoute>}
            />

          </Routes>
        </AppLayout>

        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;